import { doc, getDoc } from 'firebase/firestore';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { db } from '../firebase';
import { BoardGame } from '../models/boardgame';

export const useBoardGame = (boardGameId: string) => {
  const boardGameRef = useMemo(
    () => doc(db, 'boardgames', boardGameId),
    [boardGameId]
  );

  const { data: boardGame } = useQuery(
    `/boardgame/${boardGameId}`,
    async () => {
      const snapshot = await getDoc(boardGameRef);
      if (snapshot.exists()) {
        return snapshot.data() as BoardGame;
      }
      return null;
    }
  );

  return boardGame;
};
